import { ReactNode, useEffect } from "react";

import { Avatar, message } from "antd";
import { useGetMeQuery } from "hooks/Auth/useGetMeQuery";
import { Link, useLocation, useNavigate } from "react-router-dom";
import withAuth from "hoc/useAuth";
import {
  RiHome5Fill,
  RiHome5Line,
  RiNotification2Line,
  RiNotification3Fill,
  RiShoppingBasketFill,
  RiShoppingBasketLine,
} from "react-icons/ri";
import { FaRegUser, FaUser } from "react-icons/fa6";
import CheckUserRole from "./CheckUserRole";

const DriverDashboard = ({
  children,
  title,
  back,
  header,
}: {
  children: ReactNode;
  title?: string;
  back: boolean;
  header?: ReactNode;
}) => {
  let location = useLocation();
  const navigate = useNavigate();

  const { data } = useGetMeQuery();
  const driver = data?.data;

  // useEffect(() => {
  //   if (driver && driver?.role?.key !== "driver") {
  //     navigate("/dashboard");
  //     message.info("You're not authorized");
  //   }
  // }, [driver, driver?.role?.key, navigate]);

  return (
    <div className="h-dvh flex flex-col w-full md:px-[55px] px-[10px] max-w-[600px] mx-auto">
      {/* <CheckUserRole userRole="admin" /> */}
      {location?.pathname === "/driver/home" && (
        <div className="flex pt-[10px] pb-[25px]">
          <div className="flex items-center gap-[10px]">
            <Avatar
              style={{
                backgroundColor: "#562B00",
                verticalAlign: "middle",
              }}
              size="large"
            >
              {driver && driver.firstName.charAt(0)}
            </Avatar>

            <div>
              <h3 className="text-black text-[15px] font-bold">
                Hello, {driver?.firstName}
              </h3>
              <p className="text-primary-foreground">{driver?.id}</p>
            </div>
          </div>
        </div>
      )}

      {title && (
        <div className="relative flex items-center justify-center py-4">
          {back && (
            <button
              className="absolute left-0 font-medium"
              onClick={() => navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                />
              </svg>
            </button>
          )}
          <div className="font-medium">{title}</div>
        </div>
      )}
      <div>{header}</div>

      <div className="flex-1 overflow-y-scroll">
        {children}
        {/* <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview />
        <OrderPreview /> */}
      </div>
      <div className="flex pt-[10px] pb-[25px]">
        <div className="grid grid-cols-4 w-full">
          <Link
            to="/driver/home"
            className={`flex flex-col items-center gap-[8px] mb-1 py-[8px] text-[13px] justify-center ${
              location?.pathname.includes("/driver/home")
                ? "text-orange"
                : "text-[#A8A8A8]"
            }`}
          >
            {location?.pathname === "/driver/home" ? (
              <RiHome5Fill className="text-3xl" />
            ) : (
              <RiHome5Line className="text-3xl" />
            )}
            <p>Home</p>
          </Link>
          <Link
            to="/driver/orders"
            className={`flex flex-col items-center gap-[8px] mb-1 py-[8px] text-[13px] justify-center ${
              location?.pathname.includes("/driver/orders")
                ? "text-orange"
                : "text-[#A8A8A8]"
            }`}
          >
            {location?.pathname.includes("/driver/orders") ? (
              <RiShoppingBasketFill className="text-3xl" />
            ) : (
              <RiShoppingBasketLine className="text-3xl" />
            )}
            <p>Orders</p>
          </Link>
          <Link
            to="/driver/notifications"
            className={`flex flex-col items-center gap-[8px] mb-1 py-[8px] text-[13px] justify-center ${
              location?.pathname.includes("/driver/notifications")
                ? "text-orange"
                : "text-[#A8A8A8]"
            }`}
          >
            {location?.pathname === "/driver/notifications" ? (
              <RiNotification3Fill className="text-3xl" />
            ) : (
              <RiNotification2Line className="text-3xl" />
            )}
            <p>Notification</p>
          </Link>
          <Link
            to="/driver/profile"
            className={`flex flex-col items-center gap-[8px] mb-1 py-[8px] text-[13px] justify-center ${
              location?.pathname.includes("/driver/profile")
                ? "text-orange"
                : "text-[#A8A8A8]"
            }`}
          >
            {location?.pathname === "/driver/profile" ? (
              <FaUser className="text-3xl" />
            ) : (
              <FaRegUser className="text-3xl" />
            )}
            <p>Profile</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withAuth(DriverDashboard);

const OrderPreview = () => {
  return (
    <div className="flex gap-[10px] mb-[25px]">
      <Box />
      <div className="flex-1 flex justify-between gap-[10px]">
        <span>
          <h3 className="text-black">IS: 5780</h3>
          <p className="text-grey text-[11px] mb-[16px]">
            Adebola Akinyemi 45, Opei Road Flat A...
          </p>
          <div className="text-[11px] text-primary-foreground">
            Aug 20 204, 10:23 PM
          </div>
        </span>
        <div>
          <button className="bg-primary-light text-orange rounded-md p-[12px] text-[12px]">
            Pending
          </button>
        </div>
      </div>
    </div>
  );
};

const Box = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="10" fill="#F6F6F6" />
      <path
        d="M21.9922 11.6738C22.2422 11.5254 22.5469 11.5254 22.7891 11.6738L31.3203 16.8613C31.5234 16.9863 31.6484 17.2129 31.6484 17.4473L22.3906 23.6715L13.125 17.5246V17.4465C13.125 17.2121 13.25 16.9855 13.4531 16.8684L21.9922 11.6738Z"
        fill="#F3C07B"
      />
      <path
        d="M22.3875 22.6924L31.2625 17.3018C31.3014 17.2786 31.3458 17.2661 31.3911 17.2656C31.4364 17.2652 31.4809 17.2767 31.5205 17.2991C31.5598 17.3215 31.5925 17.3539 31.6153 17.3931C31.6381 17.4323 31.65 17.4768 31.65 17.5221V27.1627C31.6502 27.3949 31.5905 27.6231 31.477 27.8256C31.3634 28.0281 31.1997 28.198 31.0016 28.3189L22.6891 33.3658C22.6679 33.3775 22.6449 33.3853 22.6211 33.3892C22.6001 33.3955 22.5782 33.3985 22.5563 33.3978C22.4675 33.4227 22.3748 33.4297 22.2834 33.4186C22.1919 33.4075 22.1036 33.3785 22.0234 33.333H22.0281L20.1562 24.844L22.3875 22.6924Z"
        fill="#FFCE7C"
      />
      <path
        d="M22.3906 33.1427V22.6973L13.5234 17.3067C13.4843 17.2815 13.4391 17.2674 13.3925 17.2658C13.346 17.2642 13.2999 17.2751 13.2591 17.2975C13.2183 17.3199 13.1843 17.3529 13.1607 17.393C13.1371 17.4332 13.1248 17.4789 13.125 17.5255V27.1661C13.125 27.6427 13.375 28.0802 13.7734 28.3224L22.0313 33.338C22.0665 33.3602 22.107 33.3727 22.1487 33.3739C22.1903 33.3753 22.2316 33.3655 22.2682 33.3456C22.3048 33.3258 22.3354 33.2964 22.357 33.2608C22.3785 33.225 22.3901 33.1842 22.3906 33.1427Z"
        fill="#E19747"
      />
      <path
        d="M21.3281 30.9218V29.3905C21.3281 29.2108 21.2344 29.0468 21.0859 28.953L18.8984 27.6327C18.75 27.5468 18.5625 27.6483 18.5625 27.8202V29.3514C18.5625 29.5311 18.6563 29.6952 18.8047 29.7889L20.9922 31.1093C21.1406 31.1952 21.3281 31.0936 21.3281 30.9218Z"
        fill="#D3D3D3"
      />
      <path
        d="M19.188 22.9324V19.3691L16.6255 19.1973V21.666C16.6255 21.7441 16.6646 21.8223 16.7349 21.8691L18.8286 23.1426C18.9849 23.2285 19.188 23.1199 19.188 22.9324Z"
        fill="#8C5543"
      />
      <path
        d="M25.8911 13.5645L16.6255 19.1973L19.188 20.7598L28.4536 15.1348L25.8911 13.5645Z"
        fill="#A56953"
      />
    </svg>
  );
};
